<template>
  <div class="btnparent">
    <router-link to="/home" class="loginbtn">{{ btntext }}</router-link>
  </div>
</template>

<script>
export default {
  props: { btntext: String },
};
</script>

<style>
.btnparent {
  padding: 4.167vw 2.778vw;
}
.loginbtn {
  height: 45px;
  background-color: #ff9db5;
  color: white;
  display: flex;
  justify-content: center;
  align-content: center;
  border-radius: 23px;
  font-size: 16px;
}
</style>